<template>
  <div
    class="results-status text-center"
  >
    <slot>{{ $localize('NoResultsFound') }}</slot>
  </div>
</template>